import type { CreditFeaturesResponse, FeaturesResponse } from '@/api';

type ProductFeaturesResponse = CreditFeaturesResponse | FeaturesResponse;

export const selectMonthlyPaymentData = (features: ProductFeaturesResponse) => ({
  sliderAmounts: features.monthlyPayment.map(item => item.stepAmount),
  features: features.monthlyPayment,
});

export const selectWithdrawData = (features: CreditFeaturesResponse) => ({
  sliderAmounts: features.withdraw.map(item => item.stepAmount),
  features: features.withdraw,
});

export const selectDepositData = (features: ProductFeaturesResponse) => ({
  sliderAmounts: features.deposit.map(item => item.stepAmount),
  features: features.deposit,
});
